import { useContext, useEffect, useRef, useState } from "react";
import { ContextProvider } from "../../App";
import { domainUrl } from "../utils/constant";

const useShopData = () => {
  const [FilterProducts, SetFilterProducts] = useState([]);
  const [AllProducts, SetAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setShowLoader } = useContext(ContextProvider);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setShowLoader(true);
      const data = await fetch(
        `${domainUrl}/getApprovedProducts?page=${page}&limit=${limit}`
      );

      if (data.status !== 200) {
        throw new Error("API Internal Error");
      } else {
        const json = await data.json();
        // console.log(json);

        const getVasudhaProducts = () => {
          const vasudhaProducts = json.filter((data) => {
            return data?.addedBy?.includes("vasudha");
          });

          const insteadOfVasudhaProducts = json.splice(
            vasudhaProducts.length,
            json.length
          );

          const resulted = [...insteadOfVasudhaProducts, ...vasudhaProducts];
          return resulted;
        };

        const MergerdVasudhaAtLast = getVasudhaProducts();

        SetAllProducts(MergerdVasudhaAtLast);
        SetFilterProducts(MergerdVasudhaAtLast);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoader(false);
    }
  };

  return { FilterProducts, SetFilterProducts, AllProducts, SetAllProducts };
};

export default useShopData;
